<template>
  <v-app>
    <div class="text-right" id="mainWrapper"
         style="direction: rtl">
      <router-view></router-view>
    </div>
  </v-app>
</template>
<script>


  export default {
    name: 'App',



    data: () => ({
      //
    }),
  };
</script>
